import { getStrapiMedia } from '@/lib/media';
import Image from 'next/image';
import React from 'react';

const AuthorDetailsPopup = ({ details }: any) => {
  return (
    <section className='w-full rounded-[15px] border bg-white p-[15px] shadow-[0px_3px_15px_rgba(0,0,0,0.25)] dark:border dark:border-[#3E5B6D] dark:bg-[#263843] lg:w-[450px]'>
      <section className='mb-[20px] flex items-center gap-[15px]'>
        <Image
          src={getStrapiMedia(details?.data?.attributes?.profile_pic)}
          alt=''
          width={100}
          height={100}
          className='h-[50px] w-[50px] rounded-[10px]'
        />
        <section>
          <p className='text-[18px] font-semibold dark:text-white'>
            {details?.data?.attributes?.name}
          </p>
          <p className='text-[12px] text-[#707B8D] dark:text-[#9ea8ac]'>
            {details?.data?.attributes?.designation}
          </p>
        </section>
      </section>
      <p className='text-[14px] dark:text-white'>
        {details?.data?.attributes?.description}
      </p>
    </section>
  );
};

export default AuthorDetailsPopup;
